export default "__VITE_ASSET__B3jxfHi4__"